import type { IconDefinition } from '../../types'

export default {
  details: [448, 512, [], '', 'M242.2 8.3c-9.6-11.1-26.8-11.1-36.4 0l-200 232c-7.8 9-7.8 22.3 0 31.3l200 232c9.6 11.1 26.8 11.1 36.4 0l200-232c7.8-9 7.8-22.3 0-31.3l-200-232z'],
  name: 'uiDiamondSolid',
  oldName: 'fasDiamond'
} as IconDefinition
